export const PACKAGING_CHARACTER_LABELS = {
    JEDNORAZOVY: 'Jednorazový',
    OPAKOVATELNY: 'Opakovateľne použiteľný',
};

export const PACKAGING_CHARACTER_OPTIONS = Object.entries(PACKAGING_CHARACTER_LABELS).map(([value, label]) => ({ value, label }));
